import OrderRepository from './repositories/order'
import OrderService from './services/order'

const orderRepository = new OrderRepository()

export const orderService = new OrderService({ orderRepository })
